import { mapState } from 'vuex';
const lineAddFriendUrl = process.env.VUE_APP_LINE_ADD_FRIEND_URL;

export default {
  name: 'EditMemberPending',
  data(){
    return {
      status: 0,
      lineAddFriendUrl: lineAddFriendUrl,
      message: '您的申請資料審核成功',
    }
  },
  mounted() {
    const vm = this;
    if (vm.pendingMessage) {
      vm.message = vm.pendingMessage;
    } else {
    vm.$store.dispatch('edit_member/checkApply')
      .catch((error) => {
        vm.message = error.data.message;
      })
    }
  },
  methods:{
    backToOfficial() {
      const vm = this;
      window.location = vm.lineAddFriendUrl;
    }
  },
  computed: {
    ...mapState({
      pendingMessage: state => state.sign_up.pendingMessage,
    }),
  }
}
